import { useMutation, useQueryClient } from '@tanstack/react-query';
import { catalogImageService } from '@/services/catalogImageService';
import { queryKeys } from '@/lib/queryKeys';

interface UploadCatalogImageArgs {
  catalogId: string;
  file: File;
}

interface UseUploadCatalogImageOptions {
  onError?: (error: unknown) => void;
}

export const useUploadCatalogImage = (options?: UseUploadCatalogImageOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ catalogId, file }: UploadCatalogImageArgs) => {
      await catalogImageService.uploadImage(catalogId, file);
    },
    onSuccess: (_data, variables) => {
      if (variables.catalogId) {
        void queryClient.invalidateQueries({
          queryKey: queryKeys.catalog.imageMetadata(variables.catalogId),
        });
      }
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
